import {
  SAVE_TIMESHEET_SUCCESS,
  SAVE_TECHNICIANCALLOUTSAVE_SUCCESS,
  SAVE_TECHNICIANWORKHOURS_SUCCESS
} from "../Constants";

export default (state = { type: "", message: "" }, action) => {
  switch (action.type) {
    case SAVE_TIMESHEET_SUCCESS:
      return {
        type: "Timesheet Saved Successfully",
        message: action.data
      };
    case SAVE_TECHNICIANCALLOUTSAVE_SUCCESS:
      return {
        type: "callOutSave",
        message: action.data
      };
    case SAVE_TECHNICIANWORKHOURS_SUCCESS:
      return {
        type: "Timesheet Saved Successfully",
        message: action.data
      };
    default:
      return state;
  }
};
